<template>
  <div class="but" @click="click">
    <div :class="iconClass" :style="{'background-position-y': posy + 'px'}"></div>
    <div :class="txtClass">{{txt}}</div>
    <div :class="assistantClass">{{assistant}}</div>
  </div>
</template>

<script>
export default {
  name: "menuBut",
  props:{
    txt: String,
    posy: String,
    recordCount: Number,
    isActive: Boolean
  },
  computed: {
    assistant: function (){
      if (this.recordCount == undefined){
        return ""
      }else {
        return "(" + this.recordCount + ")";
      }
    },
    iconClass: function (){
      if (this.isActive){
        return 'but-icon active'
      }else{
        return 'but-icon'
      }
    },
    txtClass: function (){
      if (this.isActive){
        return 'but-txt active'
      }else{
        return 'but-txt'
      }
    },
    assistantClass: function (){
      if (this.isActive){
        return 'assistant-txt active'
      }else{
        return 'assistant-txt'
      }
    }
  },
  methods:{
    click:function (){
      this.$emit("event-click");
    }
  }
}
</script>

<style scoped>
.but{
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 0;
  margin-top:20px;
  cursor: pointer;
}
.but-icon{
  background: url(../../assets/menu-icons-sprite.png);
  background-position-x: -10px;
  background-size: 146px 318px;
  height: 24px;
  width: 24px;
  z-index: 2;
}

.but-icon.active{
  background-position-x: 102px;
}

.but-txt
{
  border-radius: 0 50px 50px 0;
  color: #333;
  font-size: 13px;
  padding-top: 2px;
}

.but-txt.active
{
  color: #2e7eee;
}

.assistant-txt{
  margin-top: 5px;
  color: #333;
  font-size: 12px;
  text-align: center;
  width: 100%;
}
.assistant-txt.active{
  color: #2e7eee;
}


</style>
